module.exports = __webpack_public_path__ + "img/vo-920.abe51c9b.jpg";